import { brandName, heroStats } from '@/mocks/animeData';

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[92vh] items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=playful%20stylized%202d%20animation%20scene%20of%20a%20cartoon%20rooster%20mascot%20leaping%20amid%20bursting%20pop%20art%20sparks%20confetti%20and%20comic%20speed%20lines%2C%20warm%20coral%20orange%20and%20cream%20palette%2C%20bold%20flat%20vector%20illustration%2C%20dynamic%20energetic%20composition%2C%20clean%20open%20background&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="搞鸡动画首屏背景插画，卡通公鸡在波普火花中跳跃"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-24 text-center md:px-6 md:py-32">
        <span className="mx-auto inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-white/15 px-4 py-1.5 text-xs font-medium text-foreground-50 backdrop-blur md:text-sm">
          <i className="ri-fire-line text-accent-400"></i>
          追更解说 · 每集重点速览
        </span>

        <h1 className="mx-auto mt-6 font-heading text-4xl leading-tight text-foreground-50 md:text-6xl md:leading-tight">
          搞鸡动画
          <span className="mt-2 block text-xl font-normal md:text-3xl">
            剧情解析 · 名场面盘点 · 角色关系梳理
          </span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-foreground-50/85 md:text-base">
          剧情解析、名场面盘点、角色关系梳理、结局剧透与高能片段剪辑，还有分集解说帮你快速看懂每集重点。
          别追更到一半就懵，来这里一次看懂。
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#analysis"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-book-open-line"></i>
            看最新解析
          </a>
          <a
            href="#scenes"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50/15 px-7 py-3 text-sm font-bold text-foreground-50 backdrop-blur transition-colors hover:bg-background-50/25 sm:w-auto"
          >
            <i className="ri-star-smile-line"></i>
            盘点名场面
          </a>
        </div>

        <div className="mx-auto mt-14 grid max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4 md:gap-4">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl bg-foreground-950/30 px-4 py-4 text-center backdrop-blur"
            >
              <div className="font-heading text-2xl text-accent-400 md:text-3xl">{s.value}</div>
              <div className="mt-1 text-xs text-foreground-50/80 md:text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}